// ========================================
// Partner Campaign Donation Engine v2
// Alana Hadid & Tommy Marcus x Glia
// ========================================

console.log("Partner Campaign JS Loaded");

// ========================================
// CONFIGURATION
// ========================================

const CAMPAIGN_NAME = "Alana & Tommy 2026 - Mobile Wound Care";
const MONTHLY_SELLING_PLAN = 16655417443;

// ========================================
// SHOPIFY VARIANTS
// ========================================

const oneTimeVariants = {

    10: "44404135788643",
    25: "44398910177379",
    50: "44398913880163",
    100: "44398915682403",
    250: "44398916501603",
    500: "44398917124195",
    1000: "44398918008931"

};

const monthlyVariants = {

    10: "44404135723107",
    25: "44003466084451",
    50: "44003466117219",
    100: "44003466149987",
    250: "44003466182755",
    500: "44003466215523",
    1000: "44003466248291"

};

const customOneTimeVariant = "44404167180387";

const customMonthlyVariant = "44404168065123";

// ========================================
// STATE
// ========================================

let selectedOneTimeAmount = 100;

let selectedMonthlyAmount = 25;

let customOneTimeAmount = null;

let customMonthlyAmount = null;

// ========================================
// PAGE ELEMENTS
// ========================================

const donateButton =
    document.querySelector(".partner-campaign__button");

const monthlyToggle =
    document.querySelector("#partner-monthly-toggle");

const monthlyPanel =
    document.querySelector(".partner-campaign__monthly-panel");

const oneTimeButtons =
    document.querySelectorAll(
        ".partner-campaign__levels--one-time button[data-amount]"
    );

const monthlyButtons =
    document.querySelectorAll(
        ".partner-campaign__levels--monthly button[data-monthly]"
    );

// Future

const otherAmountButton =
    document.querySelector(".partner-campaign__other-amount");

const otherMonthlyButton =
    document.querySelector(".partner-campaign__other-monthly");

// ========================================
// STOP IF DONATION CARD DOESN'T EXIST
// (US Give Lively Page)
// ========================================

if (!donateButton) {

    console.log("Donation card not found.");

}

// ========================================
// MONTHLY TOGGLE
// ========================================

if (monthlyToggle && monthlyPanel) {

    monthlyToggle.addEventListener("change", () => {

        monthlyPanel.classList.toggle(
            "open",
            monthlyToggle.checked
        );

    });

}

// ========================================
// ONE-TIME BUTTONS
// ========================================

oneTimeButtons.forEach(button => {

    button.addEventListener("click", () => {

        oneTimeButtons.forEach(btn =>
            btn.classList.remove("active")
        );

        button.classList.add("active");

        selectedOneTimeAmount =
            Number(button.dataset.amount);

        // Clear any custom amount
        if (customOneTimeInput) {

            customOneTimeInput.value = "";

            customOneTimeAmount = null;

        }

        console.log(
            "One-Time:",
            selectedOneTimeAmount
        );

    });

});

// ========================================
// MONTHLY BUTTONS
// ========================================

monthlyButtons.forEach(button => {

    button.addEventListener("click", () => {

        monthlyButtons.forEach(btn =>
            btn.classList.remove("active")
        );

        button.classList.add("active");

        selectedMonthlyAmount =
            Number(button.dataset.monthly);

        // Clear any custom amount
        if (customMonthlyInput) {

            customMonthlyInput.value = "";

            customMonthlyAmount = null;

        }

        console.log(
            "Monthly:",
            selectedMonthlyAmount
        );

    });

});


// ========================================
// SHOPIFY HELPERS
// ========================================

async function addDonation(
    variantId,
    monthly = false,
    quantity = 1
) {

    const item = {

        id: Number(variantId),

        quantity: quantity,

        properties: {

            Campaign: CAMPAIGN_NAME

        }

    };

    if (monthly) {

        item.selling_plan = MONTHLY_SELLING_PLAN;

    }

    const response = await fetch("/cart/add.js", {

        method: "POST",

        headers: {

            "Content-Type": "application/json"

        },

        body: JSON.stringify(item)

    });

    if (!response.ok) {

        throw new Error(await response.text());

    }

    return await response.json();

}

// ========================================
// CUSTOM AMOUNT INPUTS
// ========================================

const customOneTimeInput =
    document.querySelector("#custom-one-time");

const customMonthlyInput =
    document.querySelector("#custom-monthly");

if (customOneTimeInput) {

    customOneTimeInput.addEventListener("input", () => {

        customOneTimeAmount =
            parseInt(customOneTimeInput.value) || null;

        oneTimeButtons.forEach(btn =>
            btn.classList.remove("active")
        );

    });

}

if (customMonthlyInput) {

    customMonthlyInput.addEventListener("input", () => {

        customMonthlyAmount =
            parseInt(customMonthlyInput.value) || null;

        monthlyButtons.forEach(btn =>
            btn.classList.remove("active")
        );

    });

}

// ========================================
// UI HELPERS
// ========================================

function setDonateButtonLoading(isLoading) {

    if (!donateButton) return;

    donateButton.disabled = isLoading;

    donateButton.textContent = isLoading
        ? "Processing..."
        : "Donate Now";

}

// ========================================
// DEBUG
// ========================================

function logDonationState() {

    console.log("---------------");

    console.log("One-Time:", selectedOneTimeAmount);

    console.log("Monthly Enabled:", monthlyToggle?.checked);

    console.log("Monthly:", selectedMonthlyAmount);

    console.log("---------------");

}


// ========================================
// DONATE
// ========================================

if (donateButton) {

    donateButton.addEventListener("click", async (e) => {

        e.preventDefault();

        setDonateButtonLoading(true);

        try {

            logDonationState();

            // -----------------------------
            // ONE-TIME DONATION
            // -----------------------------

            const useCustomOneTime =
                customOneTimeAmount && customOneTimeAmount > 0;

            const oneTimeVariant =
                useCustomOneTime
                    ? customOneTimeVariant
                    : oneTimeVariants[selectedOneTimeAmount];

            const oneTimeQuantity =
                useCustomOneTime
                    ? customOneTimeAmount
                    : 1;

            if (!oneTimeVariant) {

                throw new Error(
                    "One-time donation variant not found."
                );

            }

            await addDonation(

                oneTimeVariant,

                false,

                oneTimeQuantity

            );

            // -----------------------------
            // MONTHLY DONATION
            // -----------------------------

            if (monthlyToggle &&
                monthlyToggle.checked) {

                const useCustomMonthly =
                    customMonthlyAmount &&
                    customMonthlyAmount > 0;

                const monthlyVariant =
                    useCustomMonthly
                        ? customMonthlyVariant
                        : monthlyVariants[selectedMonthlyAmount];

                const monthlyQuantity =
                    useCustomMonthly
                        ? customMonthlyAmount
                        : 1;

                if (!monthlyVariant) {

                    throw new Error(
                        "Monthly donation variant not found."
                    );

                }

                await addDonation(

                    monthlyVariant,

                    true,

                    monthlyQuantity

                );

            }

            // -----------------------------
            // CHECKOUT
            // -----------------------------

            window.location.href = "/checkout";

        }

        catch (err) {

            console.error(err);

            alert(
                "Sorry, something went wrong while preparing your donation."
            );

        }

        finally {

            setDonateButtonLoading(false);

        }

    });

}


// ========================================
// FINAL CTA DONATION CARDS
// ========================================

document.querySelectorAll(".campaign-final-cta__level").forEach(card => {

    card.addEventListener("click", function (e) {

        e.preventDefault();

        const amount = this.dataset.donate;

        // ------------------------------------
        // CUSTOM AMOUNT
        // ------------------------------------

        if (amount === "custom") {

            document.querySelector(".partner-campaign")
                ?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

            setTimeout(() => {

                customOneTimeInput?.focus();

            }, 500);

            return;

        }

        // ------------------------------------
        // FIND EXISTING BUTTON
        // ------------------------------------

        const heroButton = document.querySelector(

            `.partner-campaign__levels--one-time button[data-amount="${amount}"]`

        );

        if (!heroButton) return;

        // Trigger the exact same code
        heroButton.click();

        // Scroll back to donation widget
        document.querySelector(".partner-campaign")
            ?.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

        // Brief visual confirmation
        heroButton.classList.add("cta-selected");

        setTimeout(() => {

            heroButton.classList.remove("cta-selected");

        }, 900);

    });

});

// ========================================
// END
// ========================================

console.log("Donation Engine Ready");